module.exports = __webpack_public_path__ + "media/images/icons/loader-37000a78074176dcb69efdee285f008a.svg";